import React, { useEffect, useState } from 'react'
import { hideWidget, loadWidget } from '../../../../lib/widget-loader';
import { PostMessagesHandler } from '../../../Feed/lib/post-messages-handler';
const postMessageHandler = new PostMessagesHandler();

export const WidgetOnly = ({ merchantId, brandColor, handleDesign, handleText, popupMessage, isPopupMessageStep }) => {
    const [contentRef, setContentRef] = useState(null)
    useEffect(() => {
        postMessageHandler.subscribe();

        return function cleanup() {
            hideWidget();
            postMessageHandler.destroy();
        };
    }, []);

    const initWidget = () => {
        contentRef.parentElement.style.overflow = 'hidden';
        loadWidget(merchantId, '', {
            mountingNode: contentRef.parentElement,
            brandColor,
            handleDesign,
            handleText: handleText || merchantId + ' Party',
            popupMessage,
            fixPopupMessage: isPopupMessageStep,
        }
        );
    }

    useEffect(() => {
        if (contentRef) {
            initWidget();
            navigator.__defineGetter__('userAgent', function () {
                return 'iPhone'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentRef])
    return (
        <div ref={setContentRef} />
    )
}